module.exports = __webpack_public_path__ + "static/media/iyengars-bakery.d5627d6d.png";